module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGUlEQVR4nGOQkJD9TwlmGDVg1IBRA4aLAQAuf0wQNfxWZwAAAABJRU5ErkJggg=="